<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Title</title>

  <script type="text/javascript" src="assets/js/jquery-2.1.1.min.js"></script>

</head>
<body class="mfa-body">
<div class="nk-app-root">
  <div class="nk-main">
    <div class="nk-wrap nk-wrap-nosidebar">
      <div class="nk-content ">
        <div class="nk-block nk-block-middle nk-auth-body  wide-xs">
          <div class="card">
            <div class="card-inner card-inner-lg">
              <div class="pb-2">
                <img class="logo-img logo-img-lg" [src]="logo" alt="logo">
              </div>
              <div class="nk-block-head">
                <div class="nk-block-head-content">
                  <h5 class="nk-block-title">Two factor authentication</h5>
                  <div class="nk-block-des">
                    <p>Enter the 6-digit code below</p>
                  </div>
                </div>
              </div>
              <form #form="ngForm" id="form" (ngSubmit)='verifyCode(form)' novalidate>
                <div class="row mt-3">
                  <div class="col-1"></div>
                  <div class="col">
                    <div class="form__pincode justify-content-center d-flex">
                      <input id="firstInput" name="first" ngModel  #first="ngModel" class="inputs" type="tel"  maxlength="1" pattern="[\d]*" tabindex="1" placeholder="·" autocomplete="off">
                      <input name="second" ngModel  #second="ngModel" class="inputs" type="tel"  maxlength="1" pattern="[\d]*" tabindex="2" placeholder="·" autocomplete="off">
                      <input name="third" ngModel  #third="ngModel" class="inputs" type="tel"  maxlength="1" pattern="[\d]*" tabindex="3" placeholder="·" autocomplete="off">
                      <input name="fourth" ngModel  #fourth="ngModel" class="inputs" type="tel"  maxlength="1" pattern="[\d]*" tabindex="4" placeholder="·" autocomplete="off">
                      <input name="fifth" ngModel  #fifth="ngModel" class="inputs" type="tel"  maxlength="1" pattern="[\d]*" tabindex="5" placeholder="·" autocomplete="off">
                      <input name="sixth" ngModel  #sixth="ngModel" class="inputs" type="tel"  maxlength="1" pattern="[\d]*" tabindex="6" placeholder="·" autocomplete="off">
                      <input id="first" name="first" ngModel  #first="ngModel" type="hidden" >
                    </div>
                  </div>
                  <div class="col-1"></div>
                </div>
                <div class="row d-flex justify-content-center mt-3">
                  <div class="col"></div>
                  <div class="col">
                    <button id="buttonContinue" type="submit" class="btn btn-csc-primary">Verify Code</button>
                  </div>
                  <div class="col"></div>
                </div>
                <div class="row d-flex justify-content-center mt-3">
                  <div class="col"></div>
                  <div class="col">
                    <div class="d-flex justify-content-center">
                      <a id="buttonResend" class="btn btn-xs btn-light btn-resend" (click)="resendCode();">Resend Code</a>
                    </div>
                  </div>
                  <div class="col"></div>
                </div>
              </form>

              <div class="form-note-s2 text-left pt-4">
                <a routerLink='/login'  class="forgot-password" id="return2Login"><strong>Return to login</strong></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</body>
</html>




